import { useEffect } from 'react';

const useScrollToSelectedValue = ({ menuRef, selectedValue }) => {
  useEffect(() => {
    const el = menuRef.current?.querySelector(`[data-attr='${CSS.escape(selectedValue)}']`);
    if (el) menuRef.current.scrollTop = el.offsetTop;
  }, [menuRef, selectedValue]);
};

export default useScrollToSelectedValue;
